'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import UIDragHandle from 'UIComponents/draggable/UIDragHandle';
export default function nodeDragHandle() {
  return /*#__PURE__*/_jsx(UIDragHandle, {
    className: "m-right-2 folder-nav--drag-handle"
  });
}